var map = {
	"./act.svg": 923,
	"./ada.svg": 924,
	"./adx.svg": 925,
	"./ae.svg": 926,
	"./aion.svg": 927,
	"./amp.svg": 928,
	"./ant.svg": 929,
	"./ardr.svg": 930,
	"./ark.svg": 931,
	"./ast.svg": 932,
	"./atm.svg": 933,
	"./bat.svg": 934,
	"./bay.svg": 935,
	"./bcc.svg": 936,
	"./bch.svg": 937,
	"./bcn.svg": 938,
	"./bco.svg": 939,
	"./bdl.svg": 940,
	"./bela.svg": 941,
	"./blcn.svg": 942,
	"./blk.svg": 943,
	"./block.svg": 944,
	"./bnb.svg": 945,
	"./bnt.svg": 946,
	"./bq.svg": 947,
	"./bqx.svg": 948,
	"./btc.svg": 949,
	"./btcd.svg": 950,
	"./btcz.svg": 951,
	"./btg.svg": 952,
	"./btm.svg": 953,
	"./bts.svg": 954,
	"./btx.svg": 955,
	"./burst.svg": 956,
	"./cdn.svg": 957,
	"./clam.svg": 958,
	"./cloak.svg": 959,
	"./cnd.svg": 960,
	"./cnx.svg": 961,
	"./cny.svg": 962,
	"./cred.svg": 963,
	"./crpt.svg": 964,
	"./cvc.svg": 965,
	"./dash.svg": 966,
	"./dat.svg": 967,
	"./data.svg": 968,
	"./dbc.svg": 969,
	"./dcn.svg": 970,
	"./dcr.svg": 971,
	"./dent.svg": 972,
	"./dgb.svg": 973,
	"./dgd.svg": 974,
	"./doge.svg": 975,
	"./drgn.svg": 976,
	"./edg.svg": 977,
	"./edoge.svg": 978,
	"./elf.svg": 979,
	"./ella.svg": 980,
	"./emc.svg": 981,
	"./emc2.svg": 982,
	"./eng.svg": 983,
	"./eos.svg": 984,
	"./etc.svg": 985,
	"./eth.svg": 986,
	"./ethos.svg": 987,
	"./etn.svg": 988,
	"./etp.svg": 989,
	"./eur.svg": 990,
	"./evx.svg": 991,
	"./exmo.svg": 992,
	"./exp.svg": 993,
	"./fair.svg": 994,
	"./fct.svg": 995,
	"./fil.svg": 996,
	"./fldc.svg": 997,
	"./flo.svg": 998,
	"./ftc.svg": 999,
	"./fun.svg": 1000,
	"./game.svg": 1001,
	"./gas.svg": 1002,
	"./gbp.svg": 1003,
	"./gbx.svg": 1004,
	"./gbyte.svg": 1005,
	"./gno.svg": 1006,
	"./gnt.svg": 1007,
	"./grc.svg": 1008,
	"./grs.svg": 1009,
	"./gup.svg": 1010,
	"./gvt.svg": 1011,
	"./gxs.svg": 1012,
	"./hpb.svg": 1013,
	"./hsr.svg": 1014,
	"./huc.svg": 1015,
	"./hush.svg": 1016,
	"./icn.svg": 1017,
	"./icx.svg": 1018,
	"./ignis.svg": 1019,
	"./ins.svg": 1020,
	"./iop.svg": 1021,
	"./iost.svg": 1022,
	"./jpy.svg": 1023,
	"./kcs.svg": 1024,
	"./kin.svg": 1025,
	"./kmd.svg": 1026,
	"./knc.svg": 1027,
	"./krb.svg": 1028,
	"./lbc.svg": 1029,
	"./link.svg": 1030,
	"./lkk.svg": 1031,
	"./lrc.svg": 1032,
	"./lsk.svg": 1033,
	"./ltc.svg": 1034,
	"./maid.svg": 1035,
	"./mana.svg": 1036,
	"./mcap.svg": 1037,
	"./mco.svg": 1038,
	"./med.svg": 1039,
	"./miota.svg": 1040,
	"./mkr.svg": 1041,
	"./mln.svg": 1042,
	"./mnx.svg": 1043,
	"./mona.svg": 1044,
	"./mtl.svg": 1045,
	"./music.svg": 1046,
	"./nas.svg": 1047,
	"./nav.svg": 1048,
	"./ndz.svg": 1049,
	"./nebl.svg": 1050,
	"./neo.svg": 1051,
	"./neos.svg": 1052,
	"./ngc.svg": 1053,
	"./nlc2.svg": 1054,
	"./nlg.svg": 1055,
	"./nmc.svg": 1056,
	"./nxs.svg": 1057,
	"./nxt.svg": 1058,
	"./omg.svg": 1059,
	"./omni.svg": 1060,
	"./ost.svg": 1061,
	"./ox.svg": 1062,
	"./pac.svg": 1063,
	"./part.svg": 1064,
	"./pasl.svg": 1065,
	"./pay.svg": 1066,
	"./pink.svg": 1067,
	"./pirl.svg": 1068,
	"./pivx.svg": 1069,
	"./plr.svg": 1070,
	"./poe.svg": 1071,
	"./pot.svg": 1072,
	"./powr.svg": 1073,
	"./ppc.svg": 1074,
	"./ppp.svg": 1075,
	"./ppt.svg": 1076,
	"./prl.svg": 1077,
	"./pura.svg": 1078,
	"./qash.svg": 1079,
	"./qiwi.svg": 1080,
	"./qlc.svg": 1081,
	"./qsp.svg": 1082,
	"./qtum.svg": 1083,
	"./rads.svg": 1084,
	"./rcn.svg": 1085,
	"./rdd.svg": 1086,
	"./rdn.svg": 1087,
	"./rep.svg": 1088,
	"./req.svg": 1089,
	"./rhoc.svg": 1090,
	"./ric.svg": 1091,
	"./rise.svg": 1092,
	"./rlc.svg": 1093,
	"./rpx.svg": 1094,
	"./rub.svg": 1095,
	"./salt.svg": 1096,
	"./san.svg": 1097,
	"./sbd.svg": 1098,
	"./sberbank.svg": 1099,
	"./sc.svg": 1100,
	"./sky.svg": 1101,
	"./smart.svg": 1102,
	"./sngls.svg": 1103,
	"./snt.svg": 1104,
	"./sphtx.svg": 1105,
	"./srn.svg": 1106,
	"./start.svg": 1107,
	"./steem.svg": 1108,
	"./storj.svg": 1109,
	"./storm.svg": 1110,
	"./strat.svg": 1111,
	"./sub.svg": 1112,
	"./sys.svg": 1113,
	"./taas.svg": 1114,
	"./tau.svg": 1115,
	"./tix.svg": 1116,
	"./tkn.svg": 1117,
	"./tnc.svg": 1118,
	"./trig.svg": 1119,
	"./trx.svg": 1120,
	"./tzc.svg": 1121,
	"./ubq.svg": 1122,
	"./usd.svg": 1123,
	"./usdt.svg": 1124,
	"./ven.svg": 1125,
	"./veri.svg": 1126,
	"./via.svg": 1127,
	"./vivo.svg": 1128,
	"./vrc.svg": 1129,
	"./vtc.svg": 1130,
	"./wabi.svg": 1131,
	"./waves.svg": 1132,
	"./wax.svg": 1133,
	"./wtc.svg": 1134,
	"./xbc.svg": 1135,
	"./xcp.svg": 1136,
	"./xdn.svg": 1137,
	"./xem.svg": 1138,
	"./xlm.svg": 1139,
	"./xmg.svg": 1140,
	"./xmr.svg": 1141,
	"./xmy.svg": 1142,
	"./xp.svg": 1143,
	"./xpa.svg": 1144,
	"./xpm.svg": 1145,
	"./xrb.svg": 1146,
	"./xrp.svg": 1147,
	"./xtz.svg": 1148,
	"./xuc.svg": 1149,
	"./xvc.svg": 1150,
	"./xvg.svg": 1151,
	"./xzc.svg": 1152,
	"./zcl.svg": 1153,
	"./zec.svg": 1154,
	"./zen.svg": 1155,
	"./zrx.svg": 1156
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 922;